module.exports = __webpack_public_path__ + "img/allgrads_logo.431c1da0.jpg";